import React from "react";

function CryPayIndustry() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>
              Crypto Payment Industry: Transforming Financial Transactions
            </h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  The crypto payment industry is revolutionizing the way
                  individuals and businesses conduct transactions by leveraging
                  the power of blockchain technology and digital currencies. As
                  cryptocurrencies gain acceptance, the industry is reshaping
                  traditional payment models, enhancing efficiency, security,
                  and accessibility for users worldwide.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default CryPayIndustry;
